import type { PaginationRequest } from '@/types/pagination/pagination-request'
import { mergeObjectToSearchParams } from '@/utils/merge-object-to-search-params'
import { onlyNumbersString } from '@/utils/only-numbers-string'
import { useState, type ChangeEvent } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

export const useTable = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const [pagination, setPagination] = useState<PaginationRequest>({
    page: searchParams.get('page') || '1',
    limit: searchParams.get('limit') || '10'
  })
  const [searchText, setSearchText] = useState(searchParams.get('search') || '')
  const navigate = useNavigate()

  function navigateToMoreItemsPage(path: string | undefined) {
    if (path) {
      navigate(`/${path}`)
    }
  }

  function setPage(page: string) {
    const clearPage = onlyNumbersString(page)
    setPagination((prev) => ({ ...prev, page: clearPage }))
  }

  function setLimit(limit: string) {
    setPagination((prev) => ({ ...prev, limit: String(limit) }))
  }

  function handleSearchText(event: ChangeEvent<HTMLInputElement>) {
    setSearchText(event.target.value)
  }

  function resetPage() {
    if (searchParams.get('page')) {
      mergeObjectToSearchParams(searchParams, setSearchParams, [['page', '1']])
    }
  }

  function updatePaginationSearchParams(page: string, limit: string) {
    if (page === '') {
      page = '1'
    }
    mergeObjectToSearchParams(searchParams, setSearchParams, [
      ['page', page],
      ['limit', limit]
    ])
  }

  function cancelInputEnterAction(
    event: React.KeyboardEvent<HTMLInputElement>
  ) {
    if (event.key === 'Enter') {
      event.preventDefault()
    }
  }

  return {
    states: {
      searchParams,
      pagination,
      searchText
    },
    actions: {
      navigateToMoreItemsPage,
      setPage,
      setLimit,
      handleSearchText,
      updatePaginationSearchParams,
      setSearchParams,
      cancelInputEnterAction,
      resetPage
    }
  }
}
